import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEsMx from '../locales/es-MX/common.json';
import authEsMx from '../locales/es-MX/auth.json';
import tenantEsMx from '../locales/es-MX/tenant.json';
import errorsEsMx from '../locales/es-MX/errors.json';

await i18n.use(initReactI18next).init({
    lng: 'es-MX',
    fallbackLng: 'es-MX',
    defaultNS: 'common',
    ns: ['common', 'auth', 'tenant', 'errors'],
    resources: {
        'es-MX': {
            common: commonEsMx,
            auth: authEsMx,
            tenant: tenantEsMx,
            errors: errorsEsMx,
        },
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18n;
